<template>
    <div class="first-information-form3">
        <div class="edit-info" v-if="getEditionMode">
            <b-button variant="outline-dark" size="sm" @click="changeStatusDisabled(false)">
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group>
                <label for="email" class="required">
                    Email
                    <span id="email-help" class="icon-tooltip" style="margin-left: 5px;">
                        <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt=""
                    /></span>

                    <b-tooltip target="email-help">
                        Trata-se do e-mail principal, será exibido nas informações de identificação das Iniciativas e na
                        página Meu Perfil da Iniciativa.
                    </b-tooltip>
                </label>

                <b-form-input
                    id="email"
                    name="email"
                    v-model="$v.form.email.$model"
                    type="email"
                    placeholder="Digite seu e-mail"
                    :state="validateState('email')"
                    :disabled="getIsDisabled"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('email')">
                    Digite um e-mail válido
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Senha" label-for="password" class="password-field required">
                <b-input-group>
                    <b-form-input
                        id="password"
                        v-model="$v.form.password.$model"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Digite uma nova senha"
                        :state="validateState('password')"
                        :disabled="getIsDisabled"
                    >
                    </b-form-input>
                    <b-input-group-append class="btn-eye-password">
                        <b-button class="btn" @click="showPassword = !showPassword">
                            <i :class="`fas fa-${showPassword ? 'eye' : 'eye-slash'}`"></i>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>

                <b-form-invalid-feedback :state="validateState('password')">
                    <div v-if="!$v.form.password.required">
                        Campo obrigatório
                    </div>

                    <div v-if="!$v.form.password.minLength">
                        Deve conter no mínimo 8 caracteres
                    </div>

                    <div v-if="!$v.form.password.containsUppercase">
                        Deve conter no mínimo 1 letra maiúscula
                    </div>

                    <div v-if="!$v.form.password.containsNumber">
                        Deve conter no mínimo 1 número
                    </div>
                </b-form-invalid-feedback>

                <div class="password-obs">
                    <div>A senha deve conter um mínimo de 8 caracteres.</div>
                    <div>(É necessário conter, pelo menos, 1 número e 1 letra maiúscula)</div>
                </div>
            </b-form-group>

            <b-form-group label="Confirmar senha" label-for="confirmPassword" class="password-field required">
                <b-input-group>
                    <b-form-input
                        id="confirm-password"
                        v-model="$v.form.confirmPassword.$model"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        placeholder="Digite novamente sua senha"
                        :state="validateState('confirmPassword')"
                        :disabled="getIsDisabled"
                    >
                    </b-form-input>
                    <b-input-group-append class="btn-eye-password">
                        <b-button class="btn" @click="showConfirmPassword = !showConfirmPassword">
                            <i :class="`fas fa-${showConfirmPassword ? 'eye' : 'eye-slash'}`"></i>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>

                <b-form-invalid-feedback :state="validateState('confirmPassword')">
                    <div v-if="!$v.form.confirmPassword.required">
                        Campo obrigatório
                    </div>

                    <div v-if="!$v.form.confirmPassword.sameAsPassword && form.confirmPassword">
                        Senhas devem ser iguais
                    </div>
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <slot name="platform-bottom-buttons"></slot>

                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'FirstInformationForm2' })"
                    v-if="!isPlatform"
                    >Voltar</b-button
                >
                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!isPlatform"
                    >Próximo</b-button
                >

                <b-button variant="success" @click="changeStatusDisabled(true)" v-if="getEditionMode && !getIsDisabled">
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="!errorModal"
        >
            <div class="content">
                <WarningMsgModal :msg="message" v-if="!errorModal" />

                <DangerMsgModal :msg="message" v-if="errorModal" />
            </div>

            <div class="footer-buttons" v-if="!errorModal">
                <b-button variant="primary" @click="$router.push({ name: 'DashboardGridPage' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>

            <div class="footer-buttons" v-else>
                <b-button variant="danger" @click="hideModal('warning-modal-ref')">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'

const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { WarningMsgModal, DangerMsgModal },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            progress: 8.31,
            isDisabled: null,
            message: null,
            showPassword: false,
            showConfirmPassword: false,
            errorModal: false,
            form: {
                email: null,
                password: null,
                confirmPassword: null
            }
        }
    },
    validations: {
        form: {
            email: { required, email },
            password: {
                required,
                minLength: minLength(8),
                containsUppercase: function(value) {
                    return /[A-Z]/.test(value)
                },
                containsNumber: function(value) {
                    return /[0-9]/.test(value)
                }
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setProgress']),
        fetch() {
            if (Object.keys(localStorage).includes('firstInfo')) {
                this.firstInfoData = JSON.parse(localStorage.getItem('firstInfo'))
                this.setProgress(this.firstInfoData.percentual)
            }
        },
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            this.saveForm()
        },
        saveForm() {
            if (Object.keys(localStorage).includes('firstInfo')) {
                this.setIsLoading(true)
                const firstInfoData = {
                    ...JSON.parse(localStorage.getItem('firstInfo')),
                    email: this.form.email,
                    password: this.form.password,
                    password_confirmation: this.form.confirmPassword,
                    percentual: this.getProgress < this.progress ? this.progress : this.getProgress
                }

                registerFirstInformationApi
                    .createFirst(firstInfoData)
                    .then(res => {
                        this.setProgress(firstInfoData.percentual)
                        if (res.data.result.token) {
                            localStorage.setItem('usuario', JSON.stringify(res.data.result))
                        }

                        this.message = res.data.message
                        this.errorModal = false
                        localStorage.removeItem('firstInfo')
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.errorModal = true
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                        this.showModal('warning-modal-ref')
                    })
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'AboutInitiativeForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        }
    },
    mounted() {
        this.isDisabled = this.disabled
        this.fetch()
    }
}
</script>

<style scope src="./FirstInformationForm3-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-first-information-forms/FirstInformationForm3.vue